import ScrollFunc from './common/_scrollfunc.es6';
import Acc from './common/_acc.es6';
import Slider from './common/_slider.es6';
import Animation from './_animation.es6';

export default class Main {
    constructor() {
        this.screenHeight = 0;
        this.targetHeight = 0;
        this.scrollfunc = new ScrollFunc();
        this.acc = new Acc();
        this.slider = new Slider();
        this.animation = new Animation();

        this.resizeTimeout = null;

        this.init();
    }

    init() {
        //methods
        this.update();
        this.eventBind();
    }

    update() {
        this.screenHeight = window.innerHeight;
        this.targetHeight = document.querySelector('.mainvisual__target').offsetHeight;

        document.documentElement.style.setProperty('--screenHeight', `${this.screenHeight}px`);
        document.documentElement.style.setProperty('--targetHeight', `${this.targetHeight}px`);
    }

    eventBind() {
        window.onload = () => {
            const elm = document.querySelector('.wrapper');
            elm.classList.add('-ready');
        };
    }
}

// 実行
const main = () => {
    const router = new Main();
};
main();
